module.exports = __webpack_public_path__ + "static/media/cross.b195082a.svg";